export default import.meta.ROLLUP_FILE_URL_aL0IQWUqo5GnTt3EJcWCAg